import checkToken from './check_token';
import {isAdminView} from "./Util";
import {cleanUpAdminData} from "./common-apis";

const BASE_URL = process.env.REACT_APP_API_URL;
const CUBBY_BASE_URL = process.env.REACT_APP_CUBBY_API_URL;
const ORDER_MANAGER_BASE_URL = process.env.REACT_APP_ORDER_MANAGER_API_URL;

export const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'If-Match': '*'
};

const request = (method, path, body, isFullPath = false) => new Promise((resolve, reject) => {

  checkToken()
  .then((tokenData) => {
    
    let url = `${BASE_URL}${path}`;

    const requestParams = {
      method,
      headers: HEADERS,
      body: undefined,
    };

    if (tokenData) {
      requestParams.headers.Authorization = tokenData;
    }
    if (body) {
      requestParams.body = JSON.stringify(body);
    }
    url = isFullPath ? path : url;

    fetch(url, requestParams)
      .then((response) => {
        if (response.status === 401) {
          //need to logout admin user when token expires
          if (isAdminView()) {
            cleanUpAdminData();
            return reject(new Error('401'));
          } else {
            reject(Error('401'));
          }
        }
        if (response.status < 300) {
          if (response._bodyInit === '' || method === 'PUT') {
            return resolve(true);
          } else if (response.status === 204) {
            return resolve(true);
          } else {
            response.text().then((responseString) => {
              if (!responseString) {
                return resolve(true);
              }
              const json = JSON.parse(responseString);
              return resolve(json);
            });
          }
        } else {
          response.json().then((error) => {
            console.log('error', error);
            return reject(error);
          });
        }
      }).catch((err) => {
        reject(err);
      });
  })
  .catch((err) => {
    reject(err);
  })
  
});

export const cubbyRequest = (method, path, body) => new Promise((resolve, reject) => {

  checkToken()
  .then((tokenData) => {
    
    let url = `${CUBBY_BASE_URL}${path}`;

    const requestParams = {
      method,
      headers: HEADERS,
      body: undefined,
    };

    if (tokenData) {
      requestParams.headers.Authorization = tokenData;
    }
    if (body) {
      requestParams.body = JSON.stringify(body);
    }

    fetch(url, requestParams)
      .then((response) => {
        if (response.status === 401) reject(Error('401'));
        if (response.status < 300) {
          if (response._bodyInit === '' || method === 'PUT') {
            return resolve(true);
          } else if (response.status === 204) {
            return resolve(true);
          } else {
            console.log('Response JSON', response);
            const json = response.json();
            return resolve(json);
          }
        } else {
          response.json().then((error) => {
            console.log('error', error);
            return reject(error);
          });
        }
      }).catch((err) => {
        reject(err);
      });
  })
  .catch((err) => {
    reject(err);
  })
  
});

export const orderManagerRequest = (method, path, body) => new Promise((resolve, reject) => {

  checkToken()
  .then((tokenData) => {
    
    let url = `${ORDER_MANAGER_BASE_URL}${path}`;

    const requestParams = {
      method,
      headers: HEADERS,
      body: undefined,
    };

    if (tokenData) {
      requestParams.headers.Authorization = tokenData;
    }
    if (body) {
      requestParams.body = JSON.stringify(body);
    }

    fetch(url, requestParams)
      .then((response) => {
        if (response.status === 401) reject(Error('401'));
        if (response.status < 300) {
          if (response._bodyInit === '') {
            return resolve(true);
          } else if (response.status === 204) {
            return resolve(true);
          } else {
            console.log('Response JSON', response);
            const json = response.json();
            return resolve(json);
          }
        } else {
          response.json().then((error) => {
            console.log('error', error);
            return reject(error);
          });
        }
      }).catch((err) => {
        reject(err);
      });
  })
  .catch((err) => {
    reject(err);
  })
  
});

export default request;
